var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Scheduler",
    transform: "translate(-59.000000, -379.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-male-user-(3)",
    transform: "translate(60.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,0.329391568 C6.67100662,0.329391568 0.320963622,6.71769405 0.320963622,14.6009293 C0.320963622,22.4809965 6.67100662,28.869299 14.5,28.869299 C22.3289934,28.869299 28.6790364,22.4809965 28.6790364,14.6009293 C28.6790364,6.71769405 22.3289934,0.329391568 14.5,0.329391568 Z",
    id: "Path",
    stroke: "#707070",
    strokeWidth: 1.28,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,29.5185811 C8.50238756,29.5185811 4.54383681,25.5975503 4.37706183,25.4296873 C4.25119378,25.3029981 4.18196594,25.1319681 4.18825975,24.9514362 C4.19455275,24.7709035 4.27322089,24.6030405 4.40852844,24.4858532 C5.49099372,23.5293495 6.95735697,23.0099238 8.24750414,22.5506757 C9.59743883,22.0724238 10.875,21.6163427 11.2274306,20.8340368 C11.2840708,20.1657519 11.2809243,19.6463262 11.2746313,19.0445522 L11.2746313,18.7975086 C10.6987847,18.2495773 9.98133681,17.0935386 9.7358945,16.0230154 C9.31108961,15.7949749 8.79188328,15.2470443 8.63454861,13.9389778 C8.55588128,13.27386 8.74782986,12.7607684 9.01529928,12.4250424 C8.29470486,9.40350486 8.51182706,7.10092865 9.66037367,5.57432432 C10.6358507,4.28526162 12.240668,3.60747486 14.4339195,3.56630108 C15.8751083,3.56630108 16.9544271,3.95586973 17.5271263,4.66849622 C18.5435111,4.87436676 19.3176,5.40012649 19.8305126,6.22994108 C21.0451389,8.19679054 20.3528646,11.2436659 20.0035805,12.4440454 C20.2616104,12.7829392 20.4441187,13.2865289 20.3654514,13.9389778 C20.2112632,15.2502114 19.6920569,15.7949749 19.2641055,16.0261824 C19.0186632,17.0935386 18.3012153,18.2495773 17.7285152,18.7975086 L17.7253687,19.050887 C17.7222222,19.6494932 17.7159292,20.1689189 17.7725694,20.8340368 C18.1218535,21.6163427 19.3931209,22.0629227 20.7367626,22.5380068 C22.03635,22.9972549 23.5121528,23.5166805 24.5946181,24.4858532 C24.7267791,24.6062076 24.8054473,24.7740714 24.8117403,24.9514362 C24.8148876,25.1319681 24.7488062,25.3029981 24.6229382,25.4296873 C24.4561632,25.5975503 20.4976124,29.5185811 14.5,29.5185811 Z",
    id: "Path",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMale);
export default __webpack_public_path__ + "static/media/profileMale.8033687ae38a9f559681c469cfd2017b.svg";
export { ForwardRef as ReactComponent };